import React from 'react';
import UniversalNavLink from '../UniversalNavLink';
import { isLinkSelected } from './utils';
const InAppLinks = ({ isCollapsed, links, selectedHref }) => {
    return (React.createElement(React.Fragment, null, links === null || links === void 0 ? void 0 : links.map((link) => {
        const isSelected = isLinkSelected(link.href || '', selectedHref);
        let icon = link.icon;
        if (typeof icon === 'object') {
            if (isSelected) {
                icon = icon.selected;
            }
            else {
                icon = icon.unselected;
            }
        }
        return (React.createElement("li", { key: link.text },
            React.createElement(UniversalNavLink, { href: link.href, icon: icon, isCollapsed: isCollapsed, isSelected: isSelected, isSidebar: true, text: link.text })));
    })));
};
export default InAppLinks;
//# sourceMappingURL=InAppLinks.js.map
// @zapier/universal-layout@8.6.23 (c29ded5a6)
